import React, { useState, useEffect } from 'react'
import TopBar from '../../Components/BranchManager/TopBar'
import SideBar from '../../Components/BranchManager/SideBar'
import Main from '../../Components/BranchManager/Main'
import { getUserInfoSync } from '../../config/api'

const BranchManagerDashboard = () => {
  const [sidebarToggle, setSidebarToggle] = useState(false)
  const userInfo = getUserInfoSync()
  const isFirstLogin = userInfo?.first_login === true
  const [activeScreen, setActiveScreen] = useState(isFirstLogin ? 'profile' : 'dashboard')

  const handleSidebarToggle = () => {
    setSidebarToggle(!sidebarToggle)
  }

  useEffect(() => {
    // Toggle the class on body element based on sidebarToggle state
    if (sidebarToggle) {
      document.body.classList.add('toggle-sidebar')
    } else {
      document.body.classList.remove('toggle-sidebar')
    }
  }, [sidebarToggle])

  // Force profile screen if first login
  useEffect(() => {
    if (isFirstLogin && activeScreen !== 'profile') {
      setActiveScreen('profile')
    }
  }, [isFirstLogin, activeScreen])

  // Initialize Bootstrap collapse functionality
  useEffect(() => {
    // Ensure Bootstrap collapse is initialized
    const initBootstrap = () => {
      if (window.bootstrap && window.bootstrap.Collapse) {
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(element => {
          new window.bootstrap.Collapse(element, { toggle: false })
        })
      }
    }
    
    // Wait for Bootstrap to load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBootstrap)
    } else {
      initBootstrap()
    }
  }, [activeScreen])

  return (
    <>
    <TopBar onToggleSidebar={handleSidebarToggle} setActiveScreen={setActiveScreen}/>
    <SideBar activeScreen={activeScreen} setActiveScreen={setActiveScreen} isFirstLogin={isFirstLogin}/>
    <Main activeScreen={activeScreen} isFirstLogin={isFirstLogin}/>
    </>
  )
}

export default BranchManagerDashboard